
import Layout from "../components/Layout";
import InventoryContextProvider,{ useInventoryContext } from "../contexts/InventoryContext";

function InventoryQueryContent(){
    const {isLoading:isInventoryDataLoading} = useInventoryContext();
    const isLoading = isInventoryDataLoading();
    return <main
        className="main"
        id="main" 
    >
        {!isLoading&&<div>
            <h1>inventory query</h1>
            
        </div>}
    </main>;
        {/* <!-- End #main --> */};
}

export default function InventoryQuery(){
    return <InventoryContextProvider>
        <Layout>
            <InventoryQueryContent></InventoryQueryContent>
        </Layout>
    </InventoryContextProvider>;
}